module.exports = __webpack_public_path__ + "static/media/9.c1a2b7c6.jpg";